import { IAppState } from '../../redux';
import { selectUserId } from '../user';

/**
 * Проверяет является ли текущий пользователь создателем объявления.
 * Если юзерайди в объявлении или юзерайди пользователя не найден, вернет undefined.
 */
export const selectIsOfferByCurrentUser = (state: IAppState): boolean | undefined => {
  const userIdOfUser = selectUserId(state);
  const userIdOfOffer = state.offer.userId;

  if (typeof userIdOfUser !== 'number' || typeof userIdOfOffer !== 'number') {
    return undefined;
  }

  return userIdOfUser === userIdOfOffer;
};
